
import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import Navbar from '@/components/Navbar';
import ListingForm from '@/components/ListingForm';

const AddListing = () => {
  const navigate = useNavigate();
  const { subscription, profile } = useAuth();
  const [searchParams] = useSearchParams();
  const announcementId = searchParams.get('announcement');

  // Check if user has active subscription or freemium tier
  const hasActiveAccess = subscription?.subscribed || (profile?.admin_tier && profile.admin_tier === 'freemium');

  if (!hasActiveAccess) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md mx-auto text-center p-6 bg-white rounded-lg shadow-sm">
          <h2 className="text-xl font-semibold mb-4">Subscription Required</h2>
          <p className="text-gray-600 mb-6">
            You need an active subscription to add listings. Please subscribe to continue.
          </p>
          <Button onClick={() => navigate('/breeder-dashboard')}>
            Go to Dashboard
          </Button>
        </div>
      </div>
    );
  }

  const getTitle = () => {
    if (announcementId) {
      return "Add Listing to Announcement";
    }
    return "Add New Listing";
  };

  return (
    <ProtectedRoute requiredUserType="breeder">
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <ListingForm 
          mode="add" 
          title={getTitle()} 
          announcementId={announcementId || undefined}
        />
      </div>
    </ProtectedRoute>
  );
};

export default AddListing;
